import styled from 'styled-components';
import { useEffect, useRef } from 'react';

export const GraphModalAnchor = styled.div`
    position: relative;
`;

const GraphModalContainer = styled.div`
    margin-left: 4px;

    position: absolute;
    top: 0;
    left: 0;
    padding: 8px;
    border-radius: 8px;
    transform: translate(0, -50%);
    border: 2px solid ${props => props.theme.separatorColor};
    background: ${props => props.theme.backgroundColor};

    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.21);
`;

interface GraphModalProps {
    onDismiss?: () => void;
    children?: React.ReactNode;
}

export const GraphModal = (props: GraphModalProps) => {
    const dismissRef = useRef(props.onDismiss);
    dismissRef.current = props.onDismiss;

    useEffect(() => {
        const handleClick = () => {
            dismissRef.current?.();
        };

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);
    return (
        <GraphModalContainer
            onPointerDown={event => {
                event.stopPropagation();
            }}
        >
            {props.children}
        </GraphModalContainer>
    );
};
